import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import {
  CampaniaEncuesta,
  CreateTurnoCampaniaEncuestaRespuestaItem,
} from "src/app/model/campania-encuesta/campania-encuesta";

@Component({
  selector: "app-campania-encuesta-dialog",
  templateUrl: "campania-encuesta-dialog.component.html",
  styleUrls: ["./campania-encuesta-dialog.component.css"],
})
export class CampaniaEncuestaDialogComponent implements OnInit {
  encuestas: CampaniaEncuesta[] = [];
  seleccionadas: Map<number, boolean> = new Map();

  constructor(
    public dialogRef: MatDialogRef<CampaniaEncuestaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CampaniaEncuesta[],
  ) {}

  ngOnInit(): void {
    this.encuestas = this.data || [];
    for (const encuesta of this.encuestas) {
      for (const respuesta of encuesta.Respuestas) {
        this.seleccionadas.set(respuesta.Id, respuesta.Respuesta !== undefined ? respuesta.Respuesta : false);
      }
    }
  }

  getRespuesta(id: number): boolean {
    const val = this.seleccionadas.get(id);
    return val !== undefined ? val : false;
  }

  setRespuesta(id: number, value: boolean): void {
    this.seleccionadas.set(id, value);
  }

  puedeAceptar(): boolean {
    return this.encuestas.every((encuesta) =>
      encuesta.Respuestas.some((respuesta) => this.getRespuesta(respuesta.Id)),
    );
  }

  aceptar(): void {
    if (!this.puedeAceptar()) {
      return;
    }

    const result: CreateTurnoCampaniaEncuestaRespuestaItem[] = [];
    this.seleccionadas.forEach((respuesta, campaniEncuestaRespuestaId) => {
      result.push({ CampaniaEncuestaRespuestaId: campaniEncuestaRespuestaId, Respuesta: respuesta });
    });
    this.dialogRef.close(result);
  }
}
